// This is 2 seconds to match the Desktop Inbox
export const TYPING_SEND_THROTTLE_MS = 2000;

export { afterFrame } from "./afterFrame";
export { timeout } from "./timeout";
export * as format from "./format";
export * as query from "./query";
export { isTestPatient } from "./isTestPatient";
export { userflowIds } from "./userflow";
